import { useState, useMemo } from "react";
import { Menu, Drawer, Button, Input } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { NavLink, useLocation } from "react-router-dom";
import "../custom.css";

import {
  BearBlitz,
  LicknChew,
  Company,
  Soon,
  ContactUs,
  Picture,
  Videos,
  Certificate,
  PrivacyPolicy,
} from "../url";

const toPath = (p) => {
  if (!p) return "/";
  if (p.startsWith("http")) return p;
  return p.startsWith("/") ? p : `/${p}`;
};

const trimTrailingSlash = (s) =>
  s !== "/" && s.endsWith("/") ? s.slice(0, -1) : s;

export default function Main_menu() {
  const [visible, setVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();

  const showDrawer = () => setVisible(true);
  const onClose = () => {
    setVisible(false);
    setSearchTerm("");
  };

  const routeToKey = useMemo(() => {
    const map = new Map();
    map.set(toPath(Picture), "311");
    map.set(toPath(Videos), "312");
    map.set(toPath(Certificate), "313");
    map.set(toPath(ContactUs), "4");
    map.set(toPath(Soon), "1");
    map.set(toPath(PrivacyPolicy), "113");
    return map;
  }, []);

  const pathToKey = useMemo(() => {
    const pathname = trimTrailingSlash(location.pathname || "/");
    return routeToKey.get(pathname);
  }, [location.pathname, routeToKey]);

  const items = [
    {
      key: "1",
      label: "About",
      children: [
        {
          key: "11",
          type: "group",
          children: [
            {
              key: "111",
              label: <NavLink to={toPath(Soon)}>Our Team</NavLink>,
            },
            {
              key: "112",
              label: <NavLink to={toPath(Company)}>Our Company</NavLink>,
            },
            {
              key: "113",
              label: (
                <NavLink to={toPath(PrivacyPolicy)}>Privacy Policy</NavLink>
              ),
            },
          ],
        },
      ],
    },

    {
      key: "2",
      label: "Products",
      children: [
        {
          key: "21",
          type: "group",
          children: [
            // {
            //   key: "211",
            //   label: "Confectioneries",
            //   children: [
            //     {
            //       key: "2111",
            //       label: (
            //         <a
            //           href={BearBlitz}
            //           target="_blank"
            //           rel="noopener noreferrer"
            //         >
            //           Bearbitz
            //         </a>
            //       ),
            //     },
            //   ],
            // },
            // {
            //   key: "212",
            //   label: "Candies & Lollipops",
            //   children: [
            //     {
            //       key: "2121",
            //       label: (
            //         <a
            //           href={LicknChew}
            //           target="_blank"
            //           rel="noopener noreferrer"
            //         >
            //           Lick &amp; Chew
            //         </a>
            //       ),
            //     },
            //   ],
            // },
            { key: "213", label: <NavLink to={toPath(Soon)}>Coirs</NavLink> },
            {
              key: "214",
              label: (
                <NavLink to={toPath(Soon)}>
                  Homecare &amp; Personal Care
                </NavLink>
              ),
            },
            {
              key: "215",
              label: <NavLink to={toPath(Soon)}>Happy &amp; Day</NavLink>,
            },
            {
              key: "216",
              label: <NavLink to={toPath(Soon)}>Glossible</NavLink>,
            },
          ],
        },
      ],
    },

    {
      key: "3",
      label: "Gallery",
      children: [
        {
          key: "31",
          type: "group",
          children: [
            {
              key: "311",
              label: <NavLink to={toPath(Picture)}>Pictures</NavLink>,
            },
            {
              key: "312",
              label: <NavLink to={toPath(Videos)}>Videos</NavLink>,
            },
            {
              key: "313",
              label: <NavLink to={toPath(Certificate)}>Certificates</NavLink>,
            },
          ],
        },
      ],
    },

    { key: "4", label: <NavLink to={toPath(ContactUs)}>Contact</NavLink> },
  ];

  const searchItem = {
    key: "search",
    disabled: true,
    label: (
      <Input
        placeholder="Search"
        prefix={<FontAwesomeIcon icon={faSearch} />}
        className="search"
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm}
      />
    ),
  };

  return (
    <div className="main-menu">
      <div className="desktop-menu">
        <Menu
          mode="horizontal"
          items={[...items, searchItem]}
          selectedKeys={pathToKey ? [pathToKey] : []}
          className="Nav-menu"
        />
      </div>
      <div className="mobile-toggle">
        <Button
          aria-label="Open menu"
          type="text"
          icon={<MenuOutlined />}
          onClick={showDrawer}
        />
      </div>
      <Drawer
        title="Menu"
        placement="right"
        onClose={onClose}
        open={visible}
        width={280}
      >
        <Menu
          mode="inline"
          items={items}
          selectedKeys={pathToKey ? [pathToKey] : []}
          onClick={onClose}
        />
      </Drawer>
    </div>
  );
}
